import React from 'react'
import { Edit } from 'react-admin'
import WithDeleteModalToolbar from 'ui-shared/CustomToolbars/WithDeleteModalToolbar'
import OptionedProductSectionForm from 'ui-shared/Forms/OptionedProductSectionForm'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'

const FoodSectionEdit: React.FC = () => {
  return (
    <SectionWrapper title={'resources.foodsections.editSection'}>
      <Edit>
        <OptionedProductSectionForm
          entity="foods"
          toolbar={<WithDeleteModalToolbar />}
        />
      </Edit>
    </SectionWrapper>
  )
}

export default FoodSectionEdit
